import { c7Api } from './c7Api';

// --- Interfaces ---
export interface ClaseData {
  id: number;
  title: string;
  youtubeid: string;
}

class AuthCurso {
    
    private static instance: AuthCurso;
    private baseUrl:string = "api/verificar-acceso-curso"

    private constructor() { }

    public static GetInstance(): AuthCurso {
        if(!AuthCurso.instance){
            AuthCurso.instance = new AuthCurso();
        }
        return AuthCurso.instance;
    }
    
    public async VerificarAccesoCurso(data:any): Promise<any> {    
      return await c7Api.postFormData(this.baseUrl, data);
    }

    public async GetAllClassesCurso():Promise<ClaseData []> {
            return await c7Api.get("api/codigofinclases");
    } 
}

  export const authCursoLogic = AuthCurso.GetInstance();